import { z } from "zod";
import { isoDate } from "./common";

export const analyticsRangeQuerySchema = z
  .object({ from: isoDate, to: isoDate })
  .refine((range) => range.from <= range.to, "`from` must not be after `to`");
export type AnalyticsRange = z.infer<typeof analyticsRangeQuerySchema>;

export const dailyPointSchema = z.object({
  day: z.string(),
  views: z.number().int(),
  launches: z.number().int(),
  playSeconds: z.number().int(),
});
export type DailyPoint = z.infer<typeof dailyPointSchema>;

export const topGameSchema = z.object({
  gameId: z.number().int(),
  slug: z.string(),
  name: z.string(),
  views: z.number().int(),
  launches: z.number().int(),
  playSeconds: z.number().int(),
  avgSessionSeconds: z.number(),
});
export type TopGame = z.infer<typeof topGameSchema>;

export const analyticsOverviewSchema = z.object({
  totals: dailyPointSchema.omit({ day: true }),
  daily: z.array(dailyPointSchema),
  topGames: z.array(topGameSchema),
});
export type AnalyticsOverview = z.infer<typeof analyticsOverviewSchema>;

export const onlineNowSchema = z.object({
  totalSessions: z.number().int(),
  games: z.array(
    z.object({
      gameId: z.number().int(),
      slug: z.string(),
      name: z.string(),
      sessions: z.number().int(),
    }),
  ),
});
export type OnlineNow = z.infer<typeof onlineNowSchema>;

export const gameAnalyticsSchema = z.object({
  game: z.object({ id: z.number().int(), slug: z.string(), name: z.string() }),
  totals: dailyPointSchema.omit({ day: true }),
  daily: z.array(dailyPointSchema),
  byCountry: z.array(z.object({ country: z.string(), launches: z.number().int() })),
  byDevice: z.array(z.object({ device: z.string(), launches: z.number().int() })),
});
export type GameAnalytics = z.infer<typeof gameAnalyticsSchema>;

export const roiAdsConversionInputSchema = z.object({
  utmSource: z.literal("roiads"),
  utmId: z.string().min(1).max(200),
  utmCampaign: z.string().min(1).max(500),
  utmContent: z.string().min(1).max(500),
});
